import gql from 'graphql-tag';

export default gql`
  query PersistBasketValidation {
    persistBasketValidation @client
  }
`;
